import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function ResultsSection() {
  return <section className="py-24 px-4 bg-cream relative overflow-hidden" data-id="element-97">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-98"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-sage/10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-99"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-100">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white p-10 md:p-16 rounded-[3rem] shadow-warm-lg text-center" data-id="element-101">
          <div className="inline-flex items-center justify-center p-4 bg-gold/20 rounded-full mb-6 text-gold" data-id="element-102">
            <SparklesIcon className="w-8 h-8" data-id="element-103" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-espresso" data-id="element-104">
            LO QUE CAMBIA EN 7 DÍAS:
          </h2>
          <p className="text-xl md:text-2xl leading-relaxed text-espresso/90 font-medium" data-id="element-105">
            No es magia, es biología. Al quitar los químicos que inflaman tus
            tejidos y reemplazarlos por grasas saludables y harinas de raíz,
            notarás que tus zapatos te entran mejor, tus dedos recuperan su
            movilidad y esa "neblina mental" de la mañana desaparece.
          </p>
        </motion.div>
      </div>
    </section>;
}